import styled from 'styled-components'
import { SPACING, TYPOGRAPHY, BORDER_RADIUS, TRANSITIONS, FONT_WEIGHT } from '../../../styles/theme'

export const Row = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.md};
  padding: ${SPACING.md} ${SPACING.lg};
  border-radius: ${BORDER_RADIUS.lg};
  cursor: pointer;
  transition: background ${TRANSITIONS.fast};
  background: ${(p) => (p.$selected ? 'var(--color-bg-secondary)' : 'transparent')};

  &:hover {
    background: var(--color-bg-secondary);
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary, #ac6dff);
    outline-offset: -2px;
  }
`

const RADIO_SIZE = '16px'
const RADIO_DOT_SIZE = '8px'

export const Radio = styled.div<{ $selected: boolean }>`
  width: ${RADIO_SIZE};
  height: ${RADIO_SIZE};
  min-width: ${RADIO_SIZE};
  border-radius: 50%;
  border: 1.5px solid
    ${(p) => (p.$selected ? 'var(--color-primary, #ac6dff)' : 'var(--color-border-dark)')};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
  transition: border-color ${TRANSITIONS.fast};

  &::after {
    content: '';
    width: ${RADIO_DOT_SIZE};
    height: ${RADIO_DOT_SIZE};
    border-radius: 50%;
    background: ${(p) => (p.$selected ? 'var(--color-primary, #ac6dff)' : 'transparent')};
    transition: background ${TRANSITIONS.fast};
  }
`

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`

export const Title = styled.span`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-primary);
`

export const Description = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: ${TYPOGRAPHY.caption.lineHeight};
  color: var(--color-text-tertiary);
`
